// extracted by mini-css-extract-plugin
export var alternate = "Footer-module--alternate--66c65";
export var column = "Footer-module--column--fc436";
export var columnHeader = "Footer-module--column-header--9f882";
export var footer = "Footer-module--footer--8fb2c";
export var inner = "Footer-module--inner--3033d";
export var linkItem = "Footer-module--link-item--71263";